var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGambia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0117C24.8366 32.0117 32 24.8483 32 16.0117C32 7.17516 24.8366 0.0117188 16 0.0117188C7.16344 0.0117188 0 7.17516 0 16.0117C0 24.8483 7.16344 32.0117 16 32.0117Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 0.0117188C9.38566 0.0117188 3.70891 4.02584 1.27209 9.75084H30.7287C28.2918 4.02584 22.615 0.0117188 16.0003 0.0117188Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 32.0119C22.615 32.0119 28.2918 27.9978 30.7286 22.2728H1.27209C3.70891 27.9978 9.38566 32.0119 16.0003 32.0119Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4488 11.838H0.551188C0.1925 13.1688 0 14.5677 0 16.0119C0 17.4561 0.1925 18.855 0.551188 20.1859H31.4489C31.8075 18.855 32 17.4561 32 16.0119C32 14.5677 31.8075 13.1688 31.4488 11.838V11.838Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0117188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGambia);
export default __webpack_public_path__ + "static/media/gambia.e06466a3.svg";
export { ForwardRef as ReactComponent };